/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import styles from './LettingWidgetBase.module.scss';
export const LettingWidgetBase = ({ iconUrl, title, onClick, children, subtitle, isClosed = false, }) => {
    return (<div className={styles.lettingWidgetBase} onClick={onClick}>
      <div className={styles.leftSide}>
        <img src={iconUrl} width={32} height={32} alt='widget icon'/>
        <div className={styles.title}>{title}</div>
      </div>
      {!isClosed && children && (<div className={styles.rightSide}>
          {subtitle ? <p className={styles.subTitle}>{subtitle}</p> : null}
          {children}
        </div>)}
    </div>);
};
